import { useEffect } from 'react';
import { setConfig } from '@leagueplatform/core';
import { FEATURE_FLAGS } from 'common/firebase';
import { useFeatureFlags } from './use-feature-flags.hook';

export const useConfigWithFeatureFlags = (): { isLoading: boolean } => {
  const { featureFlags, isLoading: featureFlagsAreLoading } = useFeatureFlags([
    FEATURE_FLAGS.HEALTH_JOURNEY_TABS,
  ]);

  useEffect(() => {
    if (featureFlags) {
      setConfig((draft) => {
        // eslint-disable-next-line no-param-reassign
        draft.healthJourney = featureFlags[
          FEATURE_FLAGS.HEALTH_JOURNEY_TABS
        ] as { tabs?: string[] };
      });
    }
  }, [featureFlags]);

  return { isLoading: featureFlagsAreLoading };
};
